module.exports = __webpack_public_path__ + "img/logo_fullfreela.96f5c687.svg";